import { MultiSelect } from 'primereact/multiselect';
import { useGetLookUpDropdownListQuery } from '../../api';

const TechnicalServiceDeclarationDropdown = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  className = '',
  showClear = true
}) => {
  // TODO: languageId sabit olarak 1 ayarlandı, sonra değiştirilecek
  const languageId = 1;
  const { data: options = [], isLoading } = useGetLookUpDropdownListQuery({
    LanguageId: languageId,
    GroupCode: 'TECHNICAL_SERVICE_DECLARATION',
    RowCount: 100
  });

  const dropdownOptions = options
    .map((item) => {
      const numericValue = Number(item.code ?? item.lookupCode);
      return {
        label: item.translatedText || item.text,
        value: Number.isFinite(numericValue) ? numericValue : null
      };
    })
    .filter((item) => item.value !== null);

  const selectedValues = Array.isArray(value)
    ? value.map((item) => Number(item)).filter(Number.isFinite)
    : (value !== null && value !== undefined ? [Number(value)].filter(Number.isFinite) : []);

  return (
    <MultiSelect
      value={selectedValues}
      options={dropdownOptions}
      onChange={(e) => onChange((e.value || []).map((item) => Number(item)).filter(Number.isFinite))}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      showClear={showClear}
      loading={isLoading}
      display="chip"
      filter
      maxSelectedLabels={2}
    />
  );
};

export default TechnicalServiceDeclarationDropdown;
